/* MyJuly27 cart extras: shipping progress, delivery estimate, checkout acknowledgment */
(function () {
  /* ---------- Delivery estimate ---------- */
  var TZ = 'America/Denver';
  var CUTOFF_HOUR = 18; // 6pm Mountain

  function nthWeekday(year, month, weekday, n) {
    // n >= 1: nth weekday of month; n = -1: last weekday of month
    if (n > 0) {
      var first = new Date(Date.UTC(year, month, 1)).getUTCDay();
      return 1 + ((weekday - first + 7) % 7) + (n - 1) * 7;
    }
    var lastDate = new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
    var lastDay = new Date(Date.UTC(year, month, lastDate)).getUTCDay();
    return lastDate - ((lastDay - weekday + 7) % 7);
  }

  function key(y, m, d) {
    var dt = new Date(Date.UTC(y, m, d));
    return dt.toISOString().slice(0, 10);
  }

  function observed(y, m, d) {
    var day = new Date(Date.UTC(y, m, d)).getUTCDay();
    if (day === 6) return new Date(Date.UTC(y, m, d - 1)).toISOString().slice(0, 10);
    if (day === 0) return new Date(Date.UTC(y, m, d + 1)).toISOString().slice(0, 10);
    return key(y, m, d);
  }

  function holidaysFor(year) {
    return [
      observed(year, 0, 1), // New Year's Day
      key(year, 0, nthWeekday(year, 0, 1, 3)), // MLK Day
      key(year, 1, nthWeekday(year, 1, 1, 3)), // Presidents Day
      key(year, 4, nthWeekday(year, 4, 1, -1)), // Memorial Day
      observed(year, 5, 19), // Juneteenth
      observed(year, 6, 4), // Independence Day
      key(year, 8, nthWeekday(year, 8, 1, 1)), // Labor Day
      key(year, 9, nthWeekday(year, 9, 1, 2)), // Columbus Day
      observed(year, 10, 11), // Veterans Day
      key(year, 10, nthWeekday(year, 10, 4, 4)), // Thanksgiving
      observed(year, 11, 25), // Christmas
      observed(year + 1, 0, 1), // next New Year's observed (can fall Dec 31)
    ];
  }

  var holidayCache = {};
  function isHoliday(date) {
    var y = date.getUTCFullYear();
    if (!holidayCache[y]) holidayCache[y] = holidaysFor(y);
    return holidayCache[y].indexOf(date.toISOString().slice(0, 10)) !== -1;
  }

  // Working day = Monday through Saturday, not a US federal holiday
  function isWorkingDay(date) {
    return date.getUTCDay() !== 0 && !isHoliday(date);
  }

  function addWorkingDays(start, n) {
    var d = new Date(start.getTime());
    var counted = 0;
    while (counted < n) {
      d.setUTCDate(d.getUTCDate() + 1);
      if (isWorkingDay(d)) counted++;
    }
    return d;
  }

  // Today's date and hour in Mountain time, as a UTC-midnight Date
  function mountainNow(now) {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: TZ,
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      hourCycle: 'h23',
    }).formatToParts(now);
    var p = {};
    parts.forEach(function (x) {
      p[x.type] = x.value;
    });
    return {
      date: new Date(Date.UTC(+p.year, +p.month - 1, +p.day)),
      hour: +p.hour,
    };
  }

  function deliveryWindow(now, prodMin, prodMax, shipMin, shipMax) {
    var mt = mountainNow(now || new Date());
    // Orders placed after the 6pm Mountain cutoff count as received the next day.
    // Production and shipping days are counted after the day the order is received.
    var start = new Date(mt.date.getTime());
    if (mt.hour >= CUTOFF_HOUR) start.setUTCDate(start.getUTCDate() + 1);
    return {
      from: addWorkingDays(start, prodMin + shipMin),
      to: addWorkingDays(start, prodMax + shipMax),
    };
  }

  function formatRange(from, to) {
    var m = function (d) {
      return d.toLocaleDateString('en-US', { month: 'short', timeZone: 'UTC' });
    };
    if (m(from) === m(to)) return m(from) + ' ' + from.getUTCDate() + '–' + to.getUTCDate();
    return m(from) + ' ' + from.getUTCDate() + ' – ' + m(to) + ' ' + to.getUTCDate();
  }

  window.MJ27Delivery = { deliveryWindow: deliveryWindow, formatRange: formatRange, holidaysFor: holidaysFor };

  if (typeof customElements === 'undefined') return;

  if (!customElements.get('mj27-delivery-estimate')) {
    customElements.define(
      'mj27-delivery-estimate',
      class extends HTMLElement {
        connectedCallback() {
          var d = this.dataset;
          var w = deliveryWindow(new Date(), +d.prodMin, +d.prodMax, +d.shipMin, +d.shipMax);
          var target = this.querySelector('[data-range]');
          if (target) target.textContent = formatRange(w.from, w.to);
          this.hidden = false;
        }
      }
    );
  }

  /* ---------- Free shipping progress ---------- */
  function money(cents) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
  }

  if (!customElements.get('mj27-shipping-progress')) {
    customElements.define(
      'mj27-shipping-progress',
      class extends HTMLElement {
        connectedCallback() {
          this.threshold = +this.dataset.threshold;
          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.unsub = subscribe(PUB_SUB_EVENTS.cartUpdate, this.refresh.bind(this));
          }
        }
        disconnectedCallback() {
          if (this.unsub) this.unsub();
        }
        refresh() {
          var self = this;
          fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js')
            .then(function (r) {
              return r.json();
            })
            .then(function (cart) {
              self.render(cart.total_price, cart.item_count);
            })
            .catch(function () {});
        }
        render(total, count) {
          var msg = this.querySelector('[data-message]');
          var fill = this.querySelector('[data-fill]');
          var remaining = this.threshold - total;
          var pct = Math.max(0, Math.min(100, (total / this.threshold) * 100));
          this.classList.toggle('is-empty', count === 0);
          this.classList.toggle('is-complete', count > 0 && remaining <= 0);
          if (count === 0) {
            msg.innerHTML = this.dataset.emptyText;
          } else if (remaining <= 0) {
            msg.innerHTML = this.dataset.completeText;
          } else {
            msg.innerHTML = this.dataset.progressText.replace('[amount]', '<strong>' + money(remaining) + '</strong>');
          }
          if (fill) fill.style.width = (count === 0 ? 0 : pct) + '%';
        }
      }
    );
  }

  /* ---------- Checkout acknowledgment ---------- */
  if (!customElements.get('mj27-checkout-agree')) {
    customElements.define(
      'mj27-checkout-agree',
      class extends HTMLElement {
        connectedCallback() {
          this.checkbox = this.querySelector('input[type="checkbox"]');
          this.button = document.getElementById(this.dataset.button);
          if (!this.checkbox || !this.button) return;
          this.checkbox.checked = window.mj27Agreed === true;
          this.sync();
          this.checkbox.addEventListener('change', this.sync.bind(this));
        }
        sync() {
          window.mj27Agreed = this.checkbox.checked;
          this.button.disabled = !this.checkbox.checked;
          this.button.setAttribute('aria-disabled', String(!this.checkbox.checked));
          this.classList.toggle('is-checked', this.checkbox.checked);
        }
      }
    );
  }
})();
